import type {PayloadAction} from '@reduxjs/toolkit'
import {createSlice} from '@reduxjs/toolkit'

export const toolPanelFooter = createSlice({
  name: 'toolPanelFooter',
  initialState: {
    height: 0,
    isOpen: false,
  },
  reducers: {
    open(state) {
      state.isOpen = true
    },
    close(state) {
      state.isOpen = false
      state.height = 0
    },
    resize(state, action: PayloadAction<number>) {
      state.height = action.payload
    },
  },
})
